import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import styled from 'styled-components';

const StyledWrapper = styled.div`
    display: flex;
    height: 100vh;
    align-items: center;
    justify-content: center;
`;

const DefaultLayout = (props) => {
    const {
        children,
    } = props;

    return (
        <StyledWrapper>
            { children }
        </StyledWrapper>
    );
};

DefaultLayout.propTypes = {
    children: PropTypes.element.isRequired,
};

export default injectSheet()(DefaultLayout);



// WEBPACK FOOTER //
// ./src/layouts/DefaultLayout.js